<template>
  <div>
    <el-dialog title="课程内容信息" :visible.sync="stageListDialog" width="60%">
      <div class="whiteBg">
        <el-button type="primary" plain icon="el-icon-plus" @click="addStage(1)">添加学习阶段</el-button>
        <el-button type="primary" plain icon="el-icon-plus" @click="addStage(2)">添加考试阶段</el-button>
        <div v-loading="stageListLoading" v-for="(item, index) in stageList" :key="index">
          <el-card v-if="item.type == 1" style="margin-top: 10px">
            <div class="flexStyle">
              <el-form label-position="right">
                <el-form-item label="标题：">
                  <el-input v-model="item.title" placeholder="请输入标题"></el-input>
                </el-form-item>
              </el-form>
              <div>
                <el-button type="text" @click="changeIndex(index, 'up')" :disabled="index === 0"
                  icon="el-icon-top"></el-button>
                <el-button type="text" @click="changeIndex(index, 'down')" :disabled="index + 1 === stageList.length"
                  icon="el-icon-bottom"></el-button>
                <el-button type="text" @click="delStage(index)" icon="el-icon-delete"></el-button>
              </div>
            </div>
            <el-button type="primary" plain icon="el-icon-plus" @click="addCourseDialogOpen(index)">
              添加课程
            </el-button>
            <el-button type="primary" plain icon="el-icon-s-operation" @click="addExamDialogOpen(index)">
              配置考试
            </el-button>

            <dy-table style="margin-top: 12px" :columns="scColumns" :table-data="item.courseList" :isShowPager="false"
              element-loading-text="加载中" rowKeyName="uKey">
            </dy-table>

            <dy-table style="margin-top: 12px" :columns="seColumns" :table-data="item.examList" :isShowPager="false"
              element-loading-text="加载中" rowKeyName="uKey">
            </dy-table>

            <el-form style="margin-top: 10px" label-position="right">
              <el-form-item label="阶段介绍：">
                <el-input style="width: 500px" type="textarea" autosize v-model="item.description"
                  placeholder="请输入阶段介绍"></el-input>
              </el-form-item>
            </el-form>
          </el-card>

          <el-card v-if="item.type == 2" style="margin-top: 10px">
            <div class="flexStyle">
              <el-form label-position="right">
                <el-form-item label="标题：">
                  <el-input v-model="item.title" placeholder="请输入标题"></el-input>
                </el-form-item>
              </el-form>
              <div>
                <el-button type="text" @click="changeIndex(index, 'up')" :disabled="index === 0"
                  icon="el-icon-top"></el-button>
                <el-button type="text" @click="changeIndex(index, 'down')" :disabled="index + 1 === stageList.length"
                  icon="el-icon-bottom"></el-button>
                <el-button type="text" @click="delStage(index)" icon="el-icon-delete"></el-button>
              </div>
            </div>
            <el-button type="primary" plain icon="el-icon-s-operation"
              @click="addExamDialogOpen(index)">配置考试</el-button>
            <dy-table style="margin-top: 12px" :columns="seColumns" :table-data="item.examList" :isShowPager="false"
              element-loading-text="加载中" rowKeyName="uKey">
            </dy-table>
          </el-card>
        </div>

      </div>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
        <el-button type="primary" plain @click="stageListSave()">保存</el-button>
        <el-button type="danger" plain @click="() => (stageListDialog = false)">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加课程" :visible.sync="addCourseDialog" width="60%">
      <el-form>
        <el-row>
          <el-col :span="10">
            <el-form-item label="课程名称：">
              <el-input v-model="courseTitle" style="width: 200px" placeholder="请输入课程名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="课程分类：">
              <el-cascader v-model="courseCategoryId" placeholder="请选择课程分类" :options="courseCategory" clearable
                :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }"> </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="">
              <el-button type="primary" @click="addCourseSearch()"> <i class="el-icon-search"
                  style="margin-right: 5px"></i>查询
              </el-button>
              <el-button @click="addCourseSearch('refresh')"> <i class="el-icon-refresh"
                  style="margin-right: 5px"></i>重置
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <dy-table v-if="addCourseDialog" tableHeight="300" style="margin-top: 12px" :columns="cColumns"
        :table-data="addCourseList" :total="cTotal" :page-num="cPageNo" :page-size="cPageSize"
        @current-change="addCoursePageChange" @selection-change="addCourseSelChange" element-loading-text="加载中"
        rowKeyName="uKey">
      </dy-table>

      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
        <el-button type="primary" plain @click="courseSave">保存</el-button>
        <el-button type="danger" plain @click="() => (addCourseDialog = false)">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加考试" :visible.sync="addExamDialog" width="60%">

      <el-form>
        <el-row>
          <el-col :span="10">
            <el-form-item label="考试名称：">
              <el-input v-model="examTitle" style="width: 200px" placeholder="请输入课程名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="考试分类：">
              <el-cascader v-model="examCategoryId" placeholder="请选择考试分类" :options="examCategory" clearable
                :props="{ expandTrigger: 'hover', emitPath: false }"> </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="">
              <el-button type="primary" @click="addExamSearch()">
                <i class="el-icon-search" style="margin-right: 5px"></i>查询
              </el-button>
              <el-button @click="addExamSearch('refresh')">
                <i class="el-icon-refresh" style="margin-right: 5px"></i>重置
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <dy-table ref="addExamTable" v-if="addExamDialog" tableHeight="300" style="margin-top: 12px" :columns="eColumns"
        :table-data="addExamList" :total="eTotal" :page-num="ePageNo" :page-size="ePageSize"
        @current-change="addExamPageChange" @selection-change="addExamSelChange" element-loading-text="加载中"
        rowKeyName="uKey">
      </dy-table>

      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
        <el-button type="primary" plain @click="examSave()">保存</el-button>
        <el-button type="primary" plain @click="() => (addExamDialog = false)">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="课程预览" :visible.sync="previewDialog" width="80%" :close-on-click-modal="false">
      <div v-if="previewDialog" class="img-qrcode">
        <vue-qr :text="qrText" :size="200"></vue-qr>
      </div>

      <div class="qr-pop">请使用智谷APP扫码查看课程内容</div>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px;">
        <el-button v-if="course.examineStatus == 1" type="primary" plain @click="previewPass()">审核通过</el-button>
        <el-button v-if="course.examineStatus == 1" type="primary" plain
          @click="previewRejectDialogOpen()">审核失败</el-button>
        <el-button type="danger" plain @click="() => previewDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="previewRejectDialog" width="80%" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="反馈信息：">
          <el-input style="width: 500px;" :rows="4" type="textarea" v-model="rejectMsg"
            placeholder="请输入反馈信息"></el-input>
        </el-form-item>
      </el-form>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px;">
        <el-button type="primary" plain @click="previewPass('reject')">发送</el-button>
        <el-button type="danger" plain @click="() => previewRejectDialog = false">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';

import { generateUniqueString } from '@/utils/utils';

import { selectStageInfo, addStageContent, getCourseExamList, getAllCourseList } from '@/api/index2';

import { formatDate } from '@/utils/utils';
import VueQr from 'vue-qr';
import host from '@/api/index';
export default {
  name: 'projectContent',
  components: {
    DyTable,
    VueQr,
  },
  props: {
  },

  computed: {

  },
  data() {
    return {

      examCategory: [],
      courseCategory: [],

      course: {},

      stageList: [],


      stageListDialog: false,
      stageListLoading: false,
      scColumns: [],
      seColumns: [],

      editStageIndex: '',


      // course dialog
      addCourseDialog: false,

      cSearchForm: {},
      courseTitle: "",
      courseCategoryId: "",

      cColumns: [],
      addCourseList: [],
      cTotal: 0,
      cPageNo: 1,
      cPageSize: 10,

      addCourseSelList: [],

      // exam dialog
      addExamDialog: false,
      addExamLoading: false,

      eSearchForm: {},
      examTitle: '',
      examCategoryId: '',

      eColumns: [],
      addExamList: [],
      eTotal: 0,
      ePageNo: 1,
      ePageSize: 10,

      addExamSelList: [],

      // 课程预览 dialog
      previewDialog: false,
      qrText: '',
      previewRejectDialog: false,
      rejectMsg: '',


    };
  },
  mounted() {
    this.getCCategory();
    this.getECategory();

    this.scColumns = [
      {
        key: 'courseTitle',
        title: '课程名称',
      },
      {
        key: 'categoryName',
        title: '课程分类',
      },
      {
        key: 'type',
        title: '课程类型',
        render: ({ row }) => {
          if (row.type == 1) {
            return <div>学练测课程</div>;
          } else if (row.type == 2) {
            return <div>项目式课程</div>;
          }
        },
      },
      {
        key: 'updateDate',
        title: '发布时间',
      },
      {
        key: '',
        title: '操作',
        width: 300,
        render: ({ row }) => {
          return (
            <div>
              {/* <el-link type='primary' style='margin-left:12px' onClick={() => this.itemDel(row)}>
                详情
              </el-link> */}
              <el-link type='danger' style='margin-left:12px' onClick={() => this.itemDel(row)}>
                删除
              </el-link>
            </div>
          );
        },
      },
    ];
    this.cColumns = [
      {
        type: 'selection',
        width: 55,
      },
      {
        type: 'index',
        title: '序号',
      },
      {
        key: 'courseTitle',
        title: '课程名称',
      },
      {
        key: 'id',
        title: '课程ID',
      },
      {
        key: 'categoryName',
        title: '课程分类',
      },
      {
        key: 'type',
        title: '课程类型',
        render: ({ row }) => {
          if (row.type == 1) {
            return <div>学练测课程</div>;
          } else if (row.type == 2) {
            return <div>项目式课程</div>;
          }
        },
      }
    ];

    this.seColumns = [
      {
        key: 'name',
        title: '考试名称',
      },
      {
        key: 'paperName',
        title: '配置试卷名称',
      },
      {
        key: 'bgUserName',
        title: '考试创建人',
      },
      {
        key: 'updateDate',
        title: '更新时间',
      },
      {
        key: '',
        title: '操作',
        width: 300,
        render: ({ row }) => {
          return (
            <div>
              {/* <el-link type='primary' style='margin-left:12px' onClick={() => this.itemDel(row)}>
                详情
              </el-link> */}
              <el-link type='danger' style='margin-left:12px' onClick={() => this.itemDel(row)}>
                删除
              </el-link>
            </div>
          );
        },
      },
    ];
    this.eColumns = [
      {
        type: 'selection',
        width: 55,
      },
      {
        key: 'name',
        title: '考试名称',
      },
      {
        key: 'paperName',
        title: '配置试卷名称',
      },
      {
        key: 'bgUserName',
        title: '考试创建人',
      },
      {
        key: 'updateDate',
        title: '更新时间',
      }
    ];
  },
  methods: {

    async getCCategory() {
      this.courseCategory = await this.$store.dispatch('category/getCourseCategory');
    },

    async getECategory() {

    },

    // 外部调用
    contDialogOpen(row) {
      this.course = row;
      this.stageList = [];
      this.stageListDialog = true;
      this.getStageList();
    },

    getStageList() {
      let param = {
        courseId: this.course.id,
      };
      this.stageListLoading = true;
      selectStageInfo(param).then((res) => {

        if (res.result == 1) {
          this.stageList = res.data.stages || [];
          this.stageList.forEach((c) => {
            c.uKey = generateUniqueString();
            c.courseList = [];
            c.examList = [];
            c.stageContents.forEach((t) => {
              t.uKey = generateUniqueString();
              if (t.type == 1) {
                c.courseList.push(t);
              } else if (t.type == 2 || t.hasOwnProperty('examVO')) {
                c.examList.push(t);
              }
            });
          });
          console.log(res.data);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
        this.stageListLoading = false;
      });
    },

    addStage(type) {
      this.stageList.push(
        {
          type: type,
          uKey: generateUniqueString(),
          courseList: [],
          examList: [],
        }
      );
    },

    delStage(index) {
      this.stageList.splice(index, 1);
    },

    changeIndex(index, type) {
      let param = {};
      if (type === 'up') {
        param = {
          ...this.stageList[index - 1],
        };
        this.stageList[index - 1] = {
          ...this.stageList[index],
        };
        this.stageList[index] = param;
      }
      if (type === 'down') {
        param = {
          ...this.stageList[index + 1],
        };
        this.stageList[index + 1] = {
          ...this.stageList[index],
        };
        this.stageList[index] = param;
      }

      this.stageList = [...this.stageList];
    },

    stageListSave() {

      let stageList = JSON.parse(JSON.stringify(this.stageList))
      for (let i = 0; i < stageList.length; i++) {
        let s = stageList[i];
        s.stageOrder = i + 1;
        s.courseId = this.course.id;
        s.stageContents = [...s.courseList, ...s.examList];
        for (let ii = 0; ii < s.stageContents.length; ii++) {
          let c = s.stageContents[ii];
          c.contentOrder = ii + 1;
        }
      }

      let param = {
        id: this.course.id,
        type: 2,
        stages: stageList,
      };



      this.stageListLoading = true;
      console.log('param :>> ', param);
      addStageContent(param).then((res) => {
        console.log('res :>> ', res);
        if (res.result == 1) {
          this.$message({
            showClose: true,
            message: '保存成功',
            type: 'success',
          });

        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });

        }
        this.stageListLoading = false;
        this.stageListDialog = false;
      });
    },

    itemDel(row) {
      console.log('row :>> ', row);
      let arr = JSON.parse(JSON.stringify(this.stageList))
      arr.forEach(s => {
        s.courseList.forEach(c => {
          if (c.uKey == row.uKey) {
            s.courseList.splice(c, 1);
          }
        })
      })
      arr.forEach(s => {
        s.examList.forEach(c => {
          if (c.uKey == row.uKey) {
            s.examList.splice(c, 1);
          }
        })
      })
      this.$nextTick(() => {
        this.$set(this, 'stageList', arr);
        this.$forceUpdate();
      })

    },

    addCourseDialogOpen(index) {
      this.editStageIndex = index;
      this.addCourseSearch('refresh');
      this.addCourseDialog = true;
    },

    addCourseSearch(msg) {
      this.cPageNo = 1;
      this.cSearchForm = {
        courseTitle: this.courseTitle,
        categoryId: this.courseCategoryId,
      };

      if (msg == 'refresh') {
        this.courseTitle = null;
        this.courseCategoryId = null;
        this.cSearchForm = {};
      }

      this.getAddCourseList();
    },

    addCoursePageChange(val) {
      this.cPageNo = val;
      this.getAddCourseList();
    },

    getAddCourseList() {
      let param = {
        needPage: true,
        page: this.cPageNo,
        pageSize: this.cPageSize,
        ...this.cSearchForm,
      };
      console.log('param :>> ', param);
      getAllCourseList(param).then((res) => {
        console.log('res :>> ', res);
        if (res.result == 1) {

          this.addCourseList = res.data.list;
          this.cTotal = res.data.total;
          this.cPageNo = res.data.pageNum;

          for (let e of this.addCourseList) {
            e.contentId = e.id;
            e.contentType = e.type;
          }
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },

    // 选择后数据处理
    addCourseSelChange(val) {
      console.log(val);
      this.addCourseSelList = val;
    },

    courseSave() {

      let arr = JSON.parse(JSON.stringify(this.stageList[this.editStageIndex].courseList))
      let newArr = [...arr, ...this.addCourseSelList];
      newArr = newArr.filter((item, index, self) => {
        return self.findIndex((t) => t.contentId === item.contentId) === index;
      });
      this.$nextTick(() => {
        this.$set(this.stageList[this.editStageIndex], 'courseList', newArr);
        this.$forceUpdate();
      })
      this.addCourseDialog = false;
    },


    addExamDialogOpen(index) {
      this.editStageIndex = index;
      if (this.stageList[index].examList.length > 0) {
        this.$message({
          showClose: true,
          message: "已配置一个考试，不可配置多个考试，若更改考试请先删除原有考试",
          type: 'error'
        })
        return
      }
      this.addExamSearch('refresh');
      this.addExamDialog = true;
    },

    addExamSearch(msg) {
      this.ePageNo = 1;
      this.eSearchForm = {
        name: this.examTitle,
        categoryId: this.examCategoryId,
      };

      if (msg == 'refresh') {
        this.examTitle = null;
        this.addCategory = null;
        this.eSearchForm = {};
      }

      this.getAddExamList();
    },

    // 分页
    addExamPageChange(val) {
      this.ePageNo = val;
      this.getAddExamList();
    },

    getAddExamList() {
      this.addExamLoading = true;

      let param = {
        page: this.ePageNo,
        pageSize: this.ePageSize,
        type: 1,
        ...this.eSearchForm
      };

      console.log('param :>> ', param);
      getCourseExamList(param).then((res) => {

        if (res.result == 1) {
          this.eTotal = res.data.total;
          this.ePageNo = res.data.pageNum;
          this.addExamList = res.data.list;
          for (let e of this.addExamList) {
            e.contentId = e.id;
            e.contentType = 3;
          }

          console.log('this.addExamList :>> ', this.addExamList);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
        this.addExamLoading = false;

      });
    },

    addExamSelChange(val) {
      this.addExamSelList = val;

      if (val.length > 1) {
        this.$refs.addExamTable.$refs.ElTable.clearSelection();
        this.$refs.addExamTable.$refs.ElTable.toggleRowSelection(val[val.length - 1]);
        this.addExamSelList = [val[val.length - 1]];
      } else {
        this.addExamSelList = val;
      }
    },

    examSave() {
      let arr = JSON.parse(JSON.stringify(this.stageList[this.editStageIndex].examList))
      let newArr = [...arr, ...this.addExamSelList];
      newArr = newArr.filter((item, index, self) => {

        return self.findIndex((t) => t.contentId === item.contentId) === index;
      });
      this.$nextTick(() => {
        this.$set(this.stageList[this.editStageIndex], 'examList', newArr);
        this.$forceUpdate();
      })
      this.addExamDialog = false;
    },



    previewDialogOpen(row) {
      this.course = row;
      let jumpStr = JSON.stringify({
        from: "preview"
      })
      this.qrText = `{"jumpType":"16","commonId":"${row.id}","jumpStr":${jumpStr}}`
      this.previewDialog = true;
    },

    previewPass(msg) {
      let param = {
        id: this.course.id,
        examineStatus: msg == 'reject' ? 3 : 2,
      };
      if (msg == 'reject') {
        param.feedback = this.rejectMsg;
      }
      courseExamine(param).then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功',
          type: 'success',
        });
        this.previewRejectDialog = false;
        this.previewDialog = false;
        this.$parent.getList();
      });
    },

    previewRejectDialogOpen() {
      this.rejectMsg = ""
      this.previewRejectDialog = true;
    },

  },
};
</script>
<style scoped>
/* 图片容器居中显示 */
.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  height: 180px;
  overflow: hidden;
}

.flexStyle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

.img-qrcode {
  /* border: 1px solid green; */
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.qr-pop {
  text-align: center;
  color: red;
  padding: 30px 0 60px;
}

.text-title {
  font-weight: 500;
  font-size: 25px;
  margin-bottom: 15px;
}
</style>
